import React from 'react';

import Image from 'src/components/atoms/image';

import { CourseFooterBannerHighlightImageContainer } from '@components/templates/courseDetail/courseRegularBanner/footer/highlightImage/style';
import { getAssetUrl } from '@helpers/utils';
import useCourseDetail from '@hooks/course/useCourseDetail';
import { CourseEntity } from '@redux/course/type/courseDetailType';

type CourseFooterBannerHighlightImageProps = {
  courseDetailSeo: CourseEntity;
};

const CourseFooterBannerHighlightImage = ({ courseDetailSeo }: CourseFooterBannerHighlightImageProps) => {
  const { idName } = courseDetailSeo;
  const { highlightImage1xUrl } = useCourseDetail();

  const DEFAULT_COURSE_CARD = getAssetUrl('thumbnail-course-card.jpg');

  return (
    <CourseFooterBannerHighlightImageContainer>
      <Image
        style={{ borderRadius: '8px', height: '100px' }}
        src={highlightImage1xUrl || DEFAULT_COURSE_CARD}
        alt={idName}
        errorImage={DEFAULT_COURSE_CARD}
      />
    </CourseFooterBannerHighlightImageContainer>
  );
};

export default CourseFooterBannerHighlightImage;
